var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11C14.25 12.5188 13.0188 13.75 11.5 13.75C9.98126 13.75 8.75004 12.5188 8.75004 11C8.75004 9.48126 9.98126 8.25004 11.5 8.25004C13.0188 8.25004 14.25 9.48126 14.25 11Z",
    fill: "#899093"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5699 10.5901C18.5916 6.63336 15.0779 4.58337 11.5 4.58337C7.92217 4.58337 4.40852 6.63336 2.43015 10.5901C2.30112 10.8482 2.30112 11.1519 2.43015 11.41C4.40852 15.3667 7.92217 17.4167 11.5 17.4167C15.0779 17.4167 18.5916 15.3667 20.5699 11.41C20.699 11.1519 20.699 10.8482 20.5699 10.5901ZM11.5 15.5834C8.77865 15.5834 5.99826 14.0977 4.28556 11C5.99826 7.90242 8.77865 6.41671 11.5 6.41671C14.2214 6.41671 17.0018 7.90242 18.7145 11C17.0018 14.0977 14.2214 15.5834 11.5 15.5834Z",
    fill: "#899093"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.91133a0779a9b21c8aa7b9a189937a46.svg";